// Route: /cfm/feedback-request/create
import React from "react";
import FeedbackRequestSetup from "./FeedbackRequestSetup";

export default function CreateFeedbackRequest() {
    return <FeedbackRequestSetup mode="create" />;
}